import recovery from './recoveryMiddleware';

export default [recovery];
